import React from "react";

function BookHome() {
  return (
    <section className="book">
      <div className="book-inside">
        <h1 className="book-header">Lets get you started.</h1>
        <div className="book-div">
          <div className="book-div-inside">
            <h1 className="book-div-header">Book a call</h1>
            <h1 className="book-div-header">start a project</h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BookHome;
